import "../../../App.css";
import React, {useCallback, useEffect, useState} from "react";
import {Button, Form, Input, Layout, message, Radio, Result, Typography} from "antd";
import "antd/dist/reset.css";
import useAxios from "axios-hooks";
import {CheckoutSubmissionRequest} from "../../../types/CheckoutSubmissionRequest";
import {useOrderId} from "../../../hooks/UseOrderId";
import {PaymentType} from "../../../App";
import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {CheckoutStatusResult} from "../../../types/CheckoutStatusResult";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";
import WrappedCard from "../../antd/WrappedCard";
import easypaisaLogo from "../../../assets/easypaisa-logo.png";
import jazzcashLogo from "../../../assets/jazzcash-logo.png";
import "./PkDynamicWalletRequestV2Mode.css"
import IntentApp from "../shared/IntentApp";

const {Content} = Layout;

const ignore = false;
const OverdueTime = 3 * 60 * 1000;
const PollingTime = 5 * 1000;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果
function PkDynamicWalletRequestV2Mode({getCheckoutInfoData}: PaymentType) {
    const id = useOrderId();

    const [{data: putData}, executePost] =
        useAxios<CheckoutSubmissionRequest>(
            {
                url: `/v2/checkout/${id}`,
                method: "POST"
            },
            {manual: true}
        );
    console.log("[POST] checkout.putData", putData);

    const [
        {
            data: getCheckoutResultData,
            loading: pollingLoading
        },
        pollingCheckoutResult
    ] = useAxios<CheckoutStatusResult>(`/v2/orders/${id}`);

    const [submitCheckout, setSubmitCheckout] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [providerName] = useState(
        getCheckoutInfoData?.defaultChannel === "easypaisa" ? CardTypeEnum.EasyPaisa :
            getCheckoutInfoData?.defaultChannel === "jazzcash" ? CardTypeEnum.JazzCash :
                getCheckoutInfoData?.defaultChannel === "jazzcash_v2" ? CardTypeEnum.JazzCashV2 :
                    getCheckoutInfoData?.defaultChannel === "ajar:easypaisa" ? CardTypeEnum.AjarToEasyPaisa :
                        getCheckoutInfoData?.defaultChannel === "ajar:jazzcash" ? CardTypeEnum.AjarToJazzCash :
                    null);
    const [form] = Form.useForm();
    const [isFormValid, setIsFormValid] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [countDownText, setCountDownText] = useState("Ready countdown");
    const [neverCountDown, setNeverCountDown] = useState(true);
    const [isSubmitted, setIsSubmitted] = useState(getCheckoutInfoData?.automaticSubmission);

    const onFormFinish = (values: any) => {
        setSubmitCheckout(true);

        // NOTICE: 三分截止
        startOverdueCountDown();

        if (!ignore) {
            let newProviderName;
            let newReserved1;
            switch (values.providerName) {
                case CardTypeEnum.AjarToEasyPaisa:
                    newProviderName = CardTypeEnum.Ajar;
                    newReserved1 = CardTypeEnum.EasyPaisa;
                    break;
                case CardTypeEnum.AjarToJazzCash:
                    newProviderName = CardTypeEnum.Ajar;
                    newReserved1 = CardTypeEnum.JazzCash;
                    break;
                default:
                    newProviderName = values.providerName;
                    newReserved1 = null;
                    break;
            }

            executePost({
                data: {
                    id: id,
                    providerType: ProviderTypeEnum.WALLET,
                    providerName: newProviderName,
                    customerAccount: values.customerAccount,
                    customerIdCard: values.customerIdCard,
                    reserved1: newReserved1,
                    automaticSubmission:getCheckoutInfoData?.automaticSubmission
                }
            })
                .then(() => {
                    setSubmitCheckout(true);
                })
                .catch((error) => {
                    messageApi.error("Failed:" + error?.response?.data?.title);
                })
                .finally(() => {
                });
        }
    };

    const onButtonClick = () => {
        setIsSubmitting(true);
        form.submit();
        // IntentApp.handlePayment(form.getFieldValue("providerName"));
    }

    const checkFormValidity = () => {
        form.validateFields()
            .then(() => {
                setIsFormValid(true);
            })
            .catch(() => {
                setIsFormValid(false);
            });
    }

    const [isOverdueTime, setIsOverdueTime] = useState<boolean>(false);
    console.log("0.isOverdueTime", isOverdueTime);

    // NOTICE: 十秒輪詢 way1
    useEffect(() => {
        const stoppingStatuses: string[] = ["SUCCESS", "FAIL"]

        let pollingCountDown: NodeJS.Timeout;
        if (isOverdueTime) {
            console.log(
                "[Polling] Cause overdue time , so no need to process to poll"
            );
        } else if (!submitCheckout) {
            checkFormValidity();
            console.log("[Polling] no need to process to poll");
        } else {
            console.log("[Polling] pollingLoading", pollingLoading);
            if (getCheckoutResultData?.status === "PROCESSING") {
                console.log("[Polling] restart to polling");
                if (neverCountDown){
                    setNeverCountDown(false);
                    submitCountDown();
                }

                pollingCountDown = setTimeout(function () {
                    pollingCheckoutResult()
                        .then((data) => {
                            console.log("[Polling] end to polling.data", data);
                        })
                        .catch((error) => {
                            console.log("[Polling] restart to polling.error", error);
                        })
                        .finally(() => {
                        });
                }, PollingTime);
            } else if (typeof getCheckoutResultData !== "undefined" && stoppingStatuses.includes(getCheckoutResultData.status)) {
                console.log("[Polling] end to polling.data", getCheckoutResultData);
                messageApi.info("Result: " + getCheckoutResultData.status);
            }
        }
        return () => {
            if (pollingCountDown) clearTimeout(pollingCountDown);
        };
    }, [submitCheckout, pollingLoading, isOverdueTime, getCheckoutResultData]);

    useEffect(() => {
        if (!submitCheckout && isSubmitted) {
            setIsSubmitted(false);
            onFormFinish({
                providerName: getCheckoutInfoData?.defaultChannel,
                customerAccount: getCheckoutInfoData?.receiverAccount,
                customerIdCard: getCheckoutInfoData?.receiverIdCard,
                customerName: getCheckoutInfoData?.receiverName,
            });
        }
    }, [isSubmitted]);

    // NOTICE: 三分截止
    let countDown: NodeJS.Timeout;
    const startOverdueCountDown = useCallback(() => {
        console.log("[CountDown] start to count down");
        countDown = setTimeout(function () {
            console.log("[CountDown] end to count down");
            setIsOverdueTime(true);
        }, OverdueTime);
    }, []);

    const clearOverdueCountDown = () => {
        clearTimeout(countDown);
    };
    useEffect(() => {
        return () => {
            clearOverdueCountDown();
        };
    });

    const submitCountDown = () => {
        let num = 120;
        setCountDownText(formatTime(num));
        let timer = setInterval(() => {
            num--;
            setCountDownText(formatTime(num));
            if (num === 0) {
                setCountDownText("Time's Up !!!");
                clearInterval(timer);
            }
        }, 1000);
    };

    const formatTime = (seconds: number) => {
        let minutes = Math.floor(seconds / 60);
        let remainingSeconds = seconds % 60;
        return `${padZero(minutes)}:${padZero(remainingSeconds)}`;
    };

    const padZero = (num: number) => {
        return num < 10 ? `0${num}` : `${num}`;
    };

    return (
        <>
            {contextHolder}

            {/*NOTICE: 訂單未完成*/}
            {getCheckoutInfoData?.checkoutStatus === "VISITED" &&
                !submitCheckout && (
                    <Content className="dwr2-payment-container">
                        <WrappedCard cardProps={{ style: { backgroundColor: "rgba(255, 255, 255, 0)" } }}>
                            <>
                                <div className="dwr2-header">
                                    <div className="dwr2-header-content">

                                        <div>
                                            <Typography.Title level={2}
                                                              className="dwr2-amount">{getCheckoutInfoData?.title}</Typography.Title>
                                        </div>
                                        <div>
                                            <Typography.Title level={1}
                                                              className="dwr2-amount">{getCheckoutInfoData?.orderAmount}</Typography.Title>
                                            <Typography.Text>Amount (PKR)</Typography.Text>
                                        </div>
                                    </div>
                                </div>
                            </>

                            <Form
                                form={form}
                                initialValues={{providerName}}
                                onFinish={onFormFinish}
                                onChange={checkFormValidity}
                            >
                                <>
                                    <div className="dwr2-form-container">
                                        <div className="dwr2-table-header">
                                            <span>Select Channel</span>
                                            <span>ادائیگی کی قسم منتخب کریں </span>
                                        </div>
                                        <Form.Item name="providerName" className="dwr2-form-item">
                                            <Radio.Group className="dwr2-radio-group">
                                                {getCheckoutInfoData?.availableChannels.includes("easypaisa") && (
                                                    <Radio.Button value={CardTypeEnum.EasyPaisa} className="dwr2-radio-button">
                                                        <img src={easypaisaLogo} alt="Easypaisa" />
                                                        Easypaisa
                                                    </Radio.Button>
                                                )}
                                                {getCheckoutInfoData?.availableChannels.includes("jazzcash") && (
                                                    <Radio.Button value={CardTypeEnum.JazzCash} className="dwr2-radio-button">
                                                        <img src={jazzcashLogo} alt="Jazzcash" />
                                                        Jazzcash
                                                    </Radio.Button>
                                                )}
                                                {getCheckoutInfoData?.availableChannels.includes("jazzcash_v2") && (
                                                    <Radio.Button value={CardTypeEnum.JazzCashV2} className="dwr2-radio-button">
                                                        <img src={jazzcashLogo} alt="Jazzcash" />
                                                        Jazzcash
                                                    </Radio.Button>
                                                )}
                                                {getCheckoutInfoData?.availableChannels.includes("ajar:easypaisa") && (
                                                    <Radio.Button value={CardTypeEnum.AjarToEasyPaisa} className="dwr2-radio-button">
                                                        <img src={easypaisaLogo} alt="Easypaisa-a" />
                                                        Easypaisa-d
                                                    </Radio.Button>
                                                )}
                                                {getCheckoutInfoData?.availableChannels.includes("ajar:jazzcash") && (
                                                    <Radio.Button value={CardTypeEnum.AjarToJazzCash} className="dwr2-radio-button">
                                                        <img src={jazzcashLogo} alt="Jazzcash-a" />
                                                        Jazzcash-d
                                                    </Radio.Button>
                                                )}
                                            </Radio.Group>
                                        </Form.Item>

                                        <div className="dwr2-input-label">
                                            <span>Wallet account number</span>
                                            <span>والٹ اکاؤنٹ نمبر</span>
                                        </div>
                                        <Form.Item
                                            name="customerAccount"
                                            rules={[{
                                                required: true,
                                                message: "account should be an integer starting with 3 and totaling ten digits."
                                            }]}
                                            initialValue={getCheckoutInfoData?.receiverAccount}
                                            className="dwr2-form-item"
                                        >
                                            <Input />
                                        </Form.Item>

                                        <div className="dwr2-input-label">
                                            <span>CNIC</span>
                                            <span>شناختی کارڈ</span>
                                        </div>
                                        <Form.Item
                                            name="customerIdCard"
                                            rules={[{
                                                required: true,
                                                message: "CNIC should be real CNIC number and thirteen digital integer."
                                            }]}
                                            initialValue={getCheckoutInfoData?.receiverIdCard}
                                            className="dwr2-form-item"
                                        >
                                            <Input />
                                        </Form.Item>

                                        <Form.Item>
                                            <Button type="primary" className="dwr2-submit-button" onClick={onButtonClick} disabled={!isFormValid}>
                                                {isSubmitting ? "Paying..." : "Pay"}
                                            </Button>
                                        </Form.Item>
                                        <Form.Item name="reserved1" style={{ display: 'none' }}>
                                            <Input />
                                        </Form.Item>
                                    </div>
                                </>
                            </Form>
                            <p className="dwr2-footer-text">
                                After transaction please open your wallet<br/>
                                لین دین کے بعد اپنا والٹ کھولیں
                            </p>
                        </WrappedCard>
                    </Content>
                )}

            {/*NOTICE: 使用者填寫完畢送出，會看到等待付款中狀態頁面。*/}
            {submitCheckout &&
                !isOverdueTime &&
                getCheckoutResultData?.status === "PROCESSING" && (
                    <Result
                        status="info"
                        title={
                            <>
                                <div style={{textAlign: "center", color: "red"}}>
                                    Time Remaining<br/>
                                    {countDownText}
                                </div>
                                <div>
                                    1- If you are Jazz/Warid customer, please unlock your phone and you will receive an
                                    MPIN input prompt.<br/>
                                    2- If you are a customer of other network, Please login to your JazzCash App and
                                    enter your MPIN to pay
                                </div>
                            </>
                        }
                    />
                )}

            {/*NOTICE: 系統超過三分鐘後，使用者會看到訂單有問題之類訊息(後端之後會動態調整文案)。*/}
            {submitCheckout &&
                isOverdueTime &&
                getCheckoutResultData?.status === "PROCESSING" && (
                    <Result
                        status="warning"
                        title="We have not received your payment yet. If the transaction is delayed, please reach out to customer service if there is no further progress within two hours."
                    />
                )}
        </>
    );
}

export default PkDynamicWalletRequestV2Mode;
